module.exports = __webpack_public_path__ + "img/icons/new/close-dg-f4991cbbef016d9df54222d2069101e5.svg";